import { useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import useAuthenticatedRequest from "../hooks/useAuthenticatedRestCall";
import { CircularProgress, Box, Typography } from "@material-ui/core";
import { CONTENT_TYPES } from "../constants/contentTypes";
import { getDefaultQuestion } from "../components/courses/quizEditor/getDefaultQuestion";

function AddCourseContent() {
  const { levelId, courseId } = useParams();
  const history = useHistory();
  const { search } = useLocation();
  const makeAuthenticatedRequest = useAuthenticatedRequest();

  useEffect(() => {
    let isMounted = true;

    const createDraftContent = async () => {
      try {
        const urlParams = new URLSearchParams(search);
        const requestedType = urlParams.get("type") === "quiz" ? CONTENT_TYPES.quiz : CONTENT_TYPES.page;
        const requestedTitle = urlParams.get("title");

        const payload = {
          title: requestedTitle || (requestedType === CONTENT_TYPES.quiz ? "Untitled Quiz" : "Untitled Page"),
          type: requestedType,
          published: false,
        };

        if (requestedType === CONTENT_TYPES.quiz) {
          payload.questions = [getDefaultQuestion()];
        }

        const response = await makeAuthenticatedRequest(
          `${process.env.REACT_APP_COURSE_SERVICE_URL}/levels/${levelId}/courses/${courseId}/content`,
          true,
          { data: payload, method: "POST" }
        );

        if (isMounted && response?.data?.id) {
          history.replace(`/levels/${levelId}/courses/${courseId}/content/${response.data.id}/edit?new=true`);
        }
      } catch (error) {
        console.error("Failed to create draft content", error);
        history.goBack();
      }
    };

    createDraftContent();

    return () => { isMounted = false; };
  }, [levelId, courseId, history, makeAuthenticatedRequest, search]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="50vh">
      <CircularProgress size={60} />
      <Typography variant="h6" color="textSecondary" style={{ marginTop: '2rem' }}>
        Creating document...
      </Typography>
    </Box>
  );
}

export default AddCourseContent;